import Carousel from 'react-slick';

export { default as CarouselDots } from './carousel-dots';
export { default as CarouselArrows } from './carousel-arrows';
export { default as CarouselArrowIndex } from './carousel-arrow-index';

export { default as useCarousel } from './use-carousel';

export default Carousel;
